module.exports = __webpack_public_path__ + "img/model04.40cd4e24.png";